export default __webpack_public_path__ + "static/media/iPadSS2.5d878c83.png";